import { useParams } from 'react-router';

import { HelpDrawer } from '../../components/ReferenceBar/HelpDrawer/HelpDrawer.js';
import { PageID } from '../../components/ReferenceBar/HelpDrawer/types.js';

export function PageGuidePopoutRouteElement() {
  const { pageID = null } = useParams<{ pageID: PageID }>();
  return <HelpDrawer pageID={pageID} isPopout />;
}
